import { ComponentCanDeactivate } from './can-deactivate';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard  {
    canDeactivate(component: ComponentCanDeactivate): boolean {

        if (!component.canDeactivate()) {
            if (confirm('Sie haben ungespeicherte Änderungen! Wenn Sie die Seite verlassen, verlieren Sie diese.')) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }
}
